<script setup>
import { reactive } from 'vue'
import useUser from '../../../store/user.store'
import { localeDatePicker } from '../../../utils'
import { callApi } from '../../../utils'
import { useUrlQuery } from '../../../utils/useUrlQuery'
import { useQuasar } from 'quasar'
import { useI18n } from "vue-i18n"
const { t } = useI18n()

const $q = useQuasar()

const data = reactive({
  name: null,
  email: null
})

const { getUserList, loading, pagination } = useUser()
const { pushToUrl, clearUrl } = useUrlQuery(data, filter)

function filter () {
  pushToUrl()
  callApi([getUserList], {
    'page-size': parseInt(pagination.value.rowsPerPage),
    name: data.name,
    email: data.email,
  }, $q, loading, true)
}

function reset () {
  data.name = null
  data.email = null
  clearUrl()
  callApi([getUserList], { 
    'page-size': parseInt(pagination.value.rowsPerPage) 
  }, $q, loading, true)
}

</script>

<template lang='pug'>
.user-filter
  q-form(
    @submit='filter'
    @reset='reset'
    class="filter"
  )
    .column
      .col-auto.q-mb-md
        q-input(
          outlined
          v-model='data.name'
          :label='t("customer.name")'
          hide-hint
          hide-bottom-space
        )
      .col-auto.q-mb-md
        q-input(
          outlined
          v-model='data.email'
          :rules="[ (val, rules) => rules.email(val) || !val ]"
          :label='t("customer.email")'
          hide-hint
          hide-bottom-space
        )
      .col-auto.q-mb-md
        q-btn(
          style='width: 100%; height: 46px'
          :label="t('actions.clear')"
          :loading='loading'
          type="reset"
          flat
        )
      .col-auto
        q-btn(
          style='width: 100%; height: 46px'
          :label="t('actions.search')"
          :loading='loading'
          type="submit"
          outline
          size='auto'
          color='primary'
        )
</template>